export function ReviewQueueSkeleton() {
  return (
    <div aria-busy aria-label="Loading fields" className="animate-pulse">
      {Array.from({ length: 6 }, (_, index) => (
        <div
          key={index}
          className="flex items-center gap-4 border-b border-slate-100 bg-white px-3 py-4 dark:border-slate-800 dark:bg-slate-900"
        >
          <div className="h-4 w-1/5 rounded bg-slate-200 dark:bg-slate-700" />
          <div className="h-4 w-2/5 rounded bg-slate-200 dark:bg-slate-700" />
          <div className="h-4 w-1/6 rounded bg-slate-200 dark:bg-slate-700" />
        </div>
      ))}
    </div>
  );
}
